<template>
  <div>
    <el-form :inline="true" style="margin-top:20px">
      <el-form-item>
        <el-button size="medium" @click="addMatch">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="medium" @click="openExportDialog()">导入</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" style="padding-top:0" :model="searchForm">
      <el-form-item label="搜索：">
        <el-input size="medium" placeholder="请输入产品名称" v-model="searchForm.PRODUCT_NAME" @blur="checkBlur"
          @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="medium" type="primary" id="search" @click="handleSearch">筛选</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="newTableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" @change="setActualNumber" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="action" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="subData(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="delData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <div class="pagination_box" v-show="totalCount > 10">
      <!-- sizeChange是size改变的函数 -->
      <el-pagination @size-change="sizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <div style="clear:both"></div>
    <!-- <el-row style="margin-top:20px">
      <el-col :xl="{span:1,offset:22}" :lg="{span:1,offset:22}" :md="{span:2,offset:21}" style="padding-left:4px">
        <el-button @click="submitAll()">全部确认</el-button>
      </el-col>
    </el-row> -->
    <!-- 新增模态框 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增比价" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item style="margin-right: 0px;" label="产品名称：">
          <el-autocomplete v-model="addForm.PRODUCT_NAME" :fetch-suggestions="getProductList" placeholder="请输入内容"
            @select="productSelect" clearable @blur="checkValue()"></el-autocomplete>
        </el-form-item>
        <el-form-item style="margin-right: 0px;" label="订购数量：">
          <label slot="label">订购数量：</label>
          <el-input v-model="addForm.COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入模态框 -->
    <el-dialog :visible.sync="exportDialog" @close="exportDialog = false" title="导入SKU" width="400px" center>
      <el-form ref="exportForm" v-model="exportForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove"
          :on-success="handleSuccess" :name="this.exportForm.skuPrice" multiple :limit="1" accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadSKU" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportPrice">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      addForm: {
        PRODUCT_NAME: '',
        PRODUCT_CODE: '',
      },
      addDialog: false,
      tableData: [],
      newTableData: [],
      productArray: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      submitCount: 0,
      exportDialog: false,
      fileList: [],
      exportForm: {
        skuPrice: 'tmp',
      },
      file_name: '',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getInputList();
  },
  methods: {
    // 获取查看SKU列表
    getInputList() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 19,
        F_CAT_ID: Number(this.$route.params.id),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res[0].SKU_INFO;
          this.newTableData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
          this.totalCount = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 搜索
    checkBlur() {
      if (!this.searchForm.SCNAME) {
        this.searchForm.SCNAME = '';
      }
    },
    handleSearch() {
      // const params = {
      //   SERVICE_ID: '10071',
      //   OTYPE: 19,
      //   F_CAT_ID: Number(this.$route.params.id),
      //   GYS_ID: Number(sessionStorage.getItem('tcId')),
      //   PAGESIZE: this.pageSize,
      //   PAGEINDEX: this.currentPage - 1,
      // };
      // if (this.searchForm.PRODUCT_NAME) {
      //   params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      // }
      // http.post(params).then((res) => {
      //   if (res.length === 0) {
      //     this.$message.show({ text: '暂无数据', type: 'warning' });
      //   } else {
      //     this.tableData = res[0].SKU_INFO;
      //     this.totalCount = res[0].TOTAL_COUNT;
      //   }
      // }).catch((error) => {
      //   this.$message.show({ text: error, type: 'error' });
      // });
      this.getInputList();
    },
    // 新增产品
    addMatch() {
      this.addDialog = true;
    },
    // 获取产品
    getProductList(queryString, callBack) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 6,
        PRODUCT_NAME: queryString,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        result.forEach((item) => item.NAME = `${item.NAME} (${item.TYPE_UNIT})`);
        result = JSON.parse(JSON.stringify(result).replace(/NAME/g, 'value'));
        callBack(result);
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    },
    productSelect(item) {
      this.addForm.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    checkValue() {
      if (!this.addForm.PRODUCT_NAME) {
        this.addForm.PRODUCT_CODE = '';
      }
    },
    // 提交新增产品
    submitAddPrice() {
      if (!this.addForm.PRODUCT_NAME || !this.addForm.COUNT) {
        this.$message.show({ text: '请输入产品名称和订购数量', type: 'warning' });
        return false;
      }
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.addForm.COUNT)) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 20,
        F_CAT_ID: Number(this.$route.params.id),
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        PRODUCT_COUNT: this.addForm.COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.getInputList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导入
    openExportDialog() {
      this.exportDialog = true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleExportPrice() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10071',
            OTYPE: 21,
            F_CAT_ID: Number(this.$route.params.id),
            FILE_NAME: this.file_name,
          };
          http.post(params).then((res) => {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.getInputList();
            this.exportDialog = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 下载导入历史订单模板
    downLoadSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/parityproducts.xlsx';
    },
    // 设置当前产品的实收数量
    currentActualNumber(row) {
      return row.PRODUCT_COUNT;
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getInputList();
    },
    // size改变时回调函数，参数为当前size
    sizeChange(e) {
      this.pageSize = e;
      this.currentPage = 1;
      this.getInputList();
    },
    // 修改某行数据
    subData(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 4,
        DETAIL_ID: row.DETAIL_ID,
        PRODUCT_COUNT: row.PRODUCT_COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除某行数据
    delData(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 5,
        DETAIL_ID: row.DETAIL_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getInputList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变实收数量触发
    setActualNumber(count) {
      if (!(/\d/.test(count))) {
        this.$message.show({ text: '请输入正确的数量', type: 'warning' });
        return false;
      }
      this.submitCount = count;
    },
    // 点击全部确认
    submitAll() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 8,
        COMPARE_ID: Number(this.$route.params.id),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '全部确认成功', type: 'success' });
        this.getInputList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  margin-top: 20px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/checkSku.vue